export default __webpack_public_path__ + "static/media/cover.55428151.png";